import LoadEvent from '@/brain/result/load-event/LoadEvent'
import SetDefaultDistributor from '@/brain/result/set-default-distributor'
import RemoveByPosition from '@/brain/result/remove-by-position/RemoveByPosition'

const state = {
  list: []
}

const getters = {
  LIST_ITEMS: (state) => state.list
}

const mutations = {
  SET_LIST: (state, { eventItems }) => { state.list = eventItems },
  UPDATE_RESULT_ITEM: (state, { itemId, position, distributorId, lab, offer, distributorName }) => {
    const newList = state.list.map(i => {
      const info = i
      if (i._id.toString() === itemId.toString()) {
        if (!info.result) {
          info.result = {}
        }
        info.result[position] = {
          distributor: distributorId,
          lab,
          offer
        }

        info[`${position}Distributor`] = {
          _id: distributorId,
          name: distributorName
        }
      }

      return info
    })
    state.list = JSON.parse(JSON.stringify(newList))
  }
}

const actions = {
  LOAD_EVENT: LoadEvent,
  SET_DEFAULT_DISTRIBUTOR: SetDefaultDistributor,
  REMOVE_BY_POSITION: RemoveByPosition
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/view/event-result/state/index.js